import { slideDown, slideToggle, slideUp } from "js/function";
import { useEffect, useRef, useState } from "react";

//아코디언 목록
function AccordionSection(data){
    return (
        <div className={`accordionSection ${data.addClass ? data.addClass : ""}`}>
            {data.children}
        </div>
    );
}

function AccordionItem(data){
    const slideItem = useRef(null);
    const [openChk,setOpenChk] = useState(false);

    const [slideChk,setSlideChk] = useState(true);

    useEffect(()=>{
        if(data.id !== data.closeChk){
            slideUp(slideItem.current,300)
            setOpenChk(false)
        }
    },[data.closeChk])

    useEffect(()=>{
        setTimeout(() => {
            if(slideChk && data.startOpen && data.id == data.startOpen){
                setSlideChk(false);
                data.func(data.id);
                setTimeout(function(){
                    let scrollItem = slideItem.current.offsetTop;

                    slideDown(slideItem.current,300,"flex")
                    setOpenChk(true)

	                window.scrollTo({left: 0, top: scrollItem - 200, behavior: "smooth"});
                },0);
                setTimeout(() => {
                    setSlideChk(true);
                }, 300);
            }
        }, 300);
    },[data.startOpen])

    return (
        <div className={`accordionBox ${openChk ? "active" : ""}`}>
            <button type="button" onClick={(e)=>{
                if(slideChk){
                    setSlideChk(false);
                    data.func(data.id);
                    setTimeout(function(){
                        slideToggle(slideItem.current,"flex")
                        setOpenChk(!openChk)
                    },0);
                    setTimeout(() => {
                        setSlideChk(true);
                    }, 300);
                }
            }} className="accordionTitleBox accordionItem">
                <div className="accordionTextBox">
                    {data.questionIcon ? <span className="accordionIcon questionIcon">Q</span> : ""}
                    <div className="accordionTextItem">
                        <h1 className="accordionTitle" dangerouslySetInnerHTML={{__html:data.title}}/>
                        {data.subTitle ? <p className="accordionSubTitle" dangerouslySetInnerHTML={{__html:data.subTitle}}/> : ""}
                    </div>
                </div>
                <img src="/assets/images/basic/accordion_icon.svg"/>
            </button>
            <div className="answerText accordionItem" ref={slideItem}>
                {data.answerIcon ? <h1 className="accordionIcon answerIcon">A.</h1> : ""}
                <div className="accordionTextBox">
                    <div className="accordionText editerBox" dangerouslySetInnerHTML={{__html:data.text}}/>
                </div>
            </div>
        </div>
    );
}

export {AccordionSection, AccordionItem};